import { Routes } from '@angular/router';
import {DashboardComponent} from "./pages/dashboard/dashboard.component";
import {MortemRicercaAnagraficaComponent} from "./pages/mortem-ricerca-anagrafica/mortem-ricerca-anagrafica.component";
import { SchedaMorteComponent } from './scheda-morte/scheda-morte.component';


export const routes: Routes = [
  { path: '', redirectTo: '/ricerca-schede', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent },
  {path: 'ricerca-schede', component: MortemRicercaAnagraficaComponent},
  {path: 'scheda-morte', component: SchedaMorteComponent},
  {path: 'scheda-morte/:id', component: SchedaMorteComponent},
  
];
